import React, { useEffect } from "react";
import CafPendencyView from "../../../../../views/activationSales/components/simConnectivity/cafPendencyView";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
// import ExportToCsvButton from '../../../../../components/presentationals/ExportToCsvButton';
import { isEmptyObject } from "../../../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
import { simActivationCsvFilter } from "../../../../../utils/common/csvMappings/simConnectivityCsv";
import {
  fetchShowAlertActivation,
  hideAlertActivation,
} from "../../../../../redux/actions/activationSales";

const CafPendency = (props) => {
  const dispatch = useDispatch();

  const { cafPendencyObj } = useSelector(
    (state) => state.activationSalesReducer
  );

  let {
    url,
    csvEndPointUrl,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerCafPendencyAPI,
    triggerCafPendencyCsvAPI,
  } = props;

  // const [downloadCsv, setDownloadCsv] = useState(false);
  // const endpointCsvData = cafPendencyCSVObj && cafPendencyCSVObj.cafPendencyCSVData;
  // const csvData = endpointCsvData && endpointCsvData[csvEndPointUrl];

  const headers = {
    id: filterValue.orgId
      ? filterValue.orgId
      : filterValue.selectedRole.split(" - ")[2],
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    partnerRoleType: filterValue.selectedPartnerRoleName,
    section: props.section,
    moduleName: props.moduleName,
  };

  useEffect(() => {
    function fetchCafPendencyData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerCafPendencyAPI(obj));
    }
    if (isEmptyObject(cafPendencyObj && cafPendencyObj.cafPendencyData)) {
      fetchCafPendencyData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCafPendencyAPI, headerSelectedDateFrom, headerSelectedDateTo]);

  function fetchCafPendencyCsvData(tab) {
    // setDownloadCsv(true);
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: {
        ...headers,
        dispValue: tab === "rejected" || tab === "pending" ? "CAF" : "",
      },
      extraData: csvEndPointUrl,
      tab: tab,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "Mdn_CafPendency",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerCafPendencyCsvAPI(obj, (response, params) => {
        if (response?.content?.length) {
          let csvData;
          csvData = simActivationCsvFilter(
            props.filterValue.selectedJC === ""
              ? props.filterValue.selectedPartnerRoleName
              : props.filterValue.selectedJC === "ALL"
              ? props.filterValue.selectedPartnerRoleName
              : "JP",
            props.tileName.split(" ")[0].toLowerCase(),
            response.content,
            params.dispValue
          );
          csvData && csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertActivation());
          setTimeout(() => {
            dispatch(hideAlertActivation());
          }, 5000);
        }
      })
    );
  }

  return (
    <CafPendencyView
      isCsvActive={props.isCsvActive}
      fetchCafPendencyCsvData={fetchCafPendencyCsvData}
      moduleName={props.moduleName}
      section={props.section}
    />
  );
};

CafPendency.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  content: PropTypes.shape({
    ornCount: PropTypes.number,
    aoRejected: PropTypes.number,
    tvPending: PropTypes.number,
  }),
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerCafPendencyAPI: PropTypes.func,
  triggerCafPendencyCsvAPI: PropTypes.func,
};

export default CafPendency;
